// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"e661ba2f","336":"eb9513a3","338":"657d1f2b","344":"d62f7d68","379":"ff739bb5","428":"8edaf2f3","462":"bbeb0f84","471":"69b8c9e4","629":"cf3d5130","645":"e0e09a93","883":"25cc3e5b"}[chunkId] + ".chunk.js";
};